import React, { useState } from 'react';
import './FAQ.css';
import faqImage from '../../assets/people-working-call-center.jpg'; // Replace with your actual image path
import { IoIosArrowDropdownCircle , IoIosArrowDropupCircle  } from 'react-icons/io';

const faqData = [
  {
    question: 'Is Vedant Enterprises available across India?',
    answer: 'Yes, Vedant Enterprises operates its services across various locations with reliable logistics solutions.',
  },
  {
    question: 'What logistics services do you offer?',
    answer: 'We provide First Mile Pickup, Mid Mile Delivery, Last Mile Delivery, Warehouse Management, and Supply Chain Solutions.',
  },
  {
    question: 'How do you ensure timely delivery?',
    answer: 'Our experienced staff and technology-driven processes ensure safe, timely, and efficient delivery of goods.',
  },
  {
    question: 'Can I track my shipment in real time?',
    answer: 'Yes, we provide real-time tracking for all our logistics services to keep you updated at every stage.',
  },
  {    question: 'What types of goods can you handle?',
    answer: 'We transport a wide range of products including FMCG goods, electronics, industrial materials, and e-commerce shipments with proper handling and safety measures.',
  },{
    question: 'Do you provide last-mile delivery services?',
    answer: 'Yes, we specialize in last-mile delivery services ensuring your goods reach the final destination safely and on time.',
  }
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="faq-container">
      <div className="faq-header">
        <h2>Your Questions Answered</h2>
        <p className="subtext">Find answers to commonly asked questions about our logistics solutions.</p>
      </div>
      <div className="faq-below">
        <div className="faq-left">
          {faqData.map((item, index) => (
            <div
              key={index}
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                {item.question}
                <span className="icon">
                  {activeIndex === index ? <IoIosArrowDropupCircle  /> : <IoIosArrowDropdownCircle  />}
                </span>
              </div>
              {activeIndex === index && (
                <div className="faq-answer">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="faq-right">
          <div className="purple-block"></div>
          <img src={faqImage} alt="FAQ" className="faq-image" />
        </div>
      </div>
    </div>
  );
};

export default FAQ;
